export const GET_BANK_PAYMENT_RETURN_TRANSACTIONS = 'GET_BANK_PAYMENT_RETURN_TRANSACTIONS';
export const BANK_PAYMENT_RETURN_TRANSACTION_REQUEST = 'BANK_PAYMENT_RETURN_TRANSACTION_REQUEST';
export const BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE = 'BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE';